import { get } from 'lodash';

export const formatAddNewPayee = (selectedPayee, singleUse) => ({
  account_number: get(selectedPayee, 'to_account.account_number', ''),
  confirmation_of_payee: get(selectedPayee, 'confirmation_of_payee', {}),
  cop_account_name: get(selectedPayee, 'cop_account_name', ''),
  cop_account_type: get(selectedPayee, 'cop_account_type', ''),
  display_name: get(selectedPayee, 'display_name', ''),
  /**
   * {@link https://wearevm.atlassian.net/browse/ENT-9157| ENT-9157} Name should not exceed 50 characters.
   */
  name: get(selectedPayee, 'cop_account_name', '').substring(0, 50).trim(),
  reference: get(selectedPayee, 'reference', ''),
  single_use: singleUse,
  sort_code: get(selectedPayee, 'to_account.sort_code', ''),
});
